import gen from '../gen'
import router from '../../../router'
//
import uploadImage_4 from './uploadImage_4'
import uploadImage_5 from './uploadImage_5'
import {getSuggestions} from "../../../api"
import axios from 'axios'
//
var ls = require('local-storage');

const state = {
  createdAt: '',
  //
  selectedLocationVisible_uploadImage: [], //earlier it was in this page
  locationVisible_uploadImage: [],
  //
  caption_uploadImage: ' ',
  //
  emotionalAppeal_uploadImage : [],
  selectedemotionalAppeal_uploadImage: [],
  //
  qStr_tags_uploadImage: null, // emotional appeal
  qStr_tags2_uploadImage: null, // spot type
  //
  qStr_searchThisTag: '',
  //
  qStr_thisTagWasSearchedLast: '', // emotional appeal
  qStr_thisTagWasSearchedLast2: '', // spot type
  //
  openMapDialog: false
}

const getters = {
  selectedLocationVisible_uploadImage: state => state.selectedLocationVisible_uploadImage,
  openMapDialog: state => state.openMapDialog
}

const mutations = {
  //
  /* goTo_uploadImage_3(state2, payload){
    console.log("[go to uploadImage_3]", payload)
    //
    //validate fields
    //
    let checkVarsIfEmpty_arr = [] //arr of obj, obj -> fieldName, fieldValue
    /*checkVarsIfEmpty_arr.push({
      fieldName: 'Caption',
      fieldValue: payload.caption
    })*/
    //
    /*gen
      .actions
      .isEmptyField(state2, {
        checkVarsIfEmpty_arr
      })
      .then((isEmpty)=>{
      console.log("[upload_2][filed empty]", isEmpty)
        if(!isEmpty){
          //
          //if(payload.emotionalAppeal.length != 0){ // validate tag arr, check arr len
            console.log("[//go to next page]")
            //
            let url = payload.url
            let resourceType = payload.resourceType
            let publicId = payload.publicId
            //
            let geohash = payload.geohash
            let geoLocIsAvailable = payload.geoLocIsAvailable
            //
            let caption = payload.caption
            let emotionalAppeal = payload.emotionalAppeal
            let spotType = payload.spotType
            let anyoneCanVisitThisSpot = payload.anyoneCanVisitThisSpot
            //
            let createdAt = payload.createdAt
            //
            //route to upload page 3
            router.push({
              path: '/uploadImage_3',
              query: {
                url,
                resourceType,
                publicId,
                //
                createdAt,
                //
                geohash,
                geoLocIsAvailable,
                //
                caption,
                emotionalAppeal: JSON.stringify(emotionalAppeal),
                spotType:  JSON.stringify(spotType),
                anyoneCanVisitThisSpot
              }
            })
            //
            console.log("[go to 3]")
            //
          //}else{
            //gen.mutations.snackbar_alert(state, {
              //msg: 'Please select at least one tag in location visible related to the image'
            //})
          //}
        }
    })
    //
  }, */
  //
  getTags_setDropdownOptions_uploadImage(state2, payload) {
    //
    let qTag = payload.qTag
    let qStr = payload.qStr
    //
    if(qTag.length != 0 && qTag != undefined && qTag != null){
      //
      gen
        .actions
        .getTags_uploadImage(state, {
          qTag,
          qStr,
        }).then((response)=>{
        //
        let result = response.data
        //
        if(qTag == 'locationVisible'){
          state.locationVisible_uploadImage = state.locationVisible_uploadImage.concat(result) //vuetify component helping here, check duplicate
        }else if(qTag == 'emotionalAppeal'){
          state.emotionalAppeal_uploadImage = state.emotionalAppeal_uploadImage.concat(result)
        }else if(qTag == 'spotType'){
          uploadImage_4.state.spotType_uploadImage = uploadImage_4.state.spotType_uploadImage.concat(result)
        }else if(qTag == 'keywords'){
          uploadImage_5.state.keywords_uploadImage = uploadImage_5.state.keywords_uploadImage.concat(result)
        }
        //
      })
      //
    }
  }
}

const actions = {
  GET_SUGGESTIONS({commit}, payload) {
    return new Promise(async resolve => {
      let tagCatType = payload.tagCatType
      let {data} = await axios.get(getSuggestions({tagCat: tagCatType}))
      resolve(data)
    })
  }
}

export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/uploadImage_2.js